export declare type AppUrl = any

export const appRoutes = {
  root: '',
  auth: {
    main: '/auth',
    register: '/auth/register',
    login: '/auth/login',
    forgotPassword: '/auth/forgot-password',
    setPassword: '/auth/set-password',
    emailConfirmation: '/auth/email-confirmation',
    confirmation: '/auth/confirmation',
    forgotPasswordConfirmation: '/auth/forgot-password-confirmation',
    resetSetPassword: '/auth/reset-set-password',
    googleAuth: '/auth/google'
  },
  app: {
    main: '/app',
    comingSoonUsers: '/app/coming-soon-users',
    comingSoonFinance: '/app/coming-soon-finance',
    comingSoonNotification: '/app/coming-soon-notification',
    frame: '/app/container',
    upgradeAccount: '/app/upgrade-account',
    integration: {
      main: '/app/integration',
      notActivatedUser: '/app/integration/not-activated-user',
      jsTag: '/app/integration/js-tag',
      urlRedirect: '/app/integration/url',
      iframe: '/app/integration/iframe'
    },
    reports: {
      main: '/app/reports',
      realTimeAnalysis: '/app/reports/real-time-analysis',
      postAnalysis: {
        main: '/app/reports/post-analysis',
        list: '/app/reports/post-analysis',
        create: '/app/reports/post-analysis/create',
        report: '/app/reports/post-analysis/report'
      },
      claimReport: {
        main: '/app/reports/claim-report',
        view: '/app/reports/claim-report/view',
        list: '/app/reports/claim-report/list',
        create: '/app/reports/claim-report/create'
      }
    },
    notifications: {
      main: '/app/notifications',
      channels: {
        main: '/app/notifications/channels',
        settings: '/app/notifications/channels/settings',
        create: '/app/notifications/channels/create',
        edit: '/app/notifications/channels/edit'
      },
      alertRules: {
        main: '/app/notifications/alert-rules',
        settings: '/app/notifications/alert-rules/settings',
        edit: '/app/notifications/alert-rules/edit',
        create: '/app/notifications/alert-rules/create',
        alert: '/app/notifications/alert-rules/alert'
      }
    },
    users: {
      main: '/app/users',
      list: '/app/users/list',
      create: '/app/users/create',
      edit: '/app/users/edit'
    },
    finance: {
      main: '/app/finance',
      balance: '/app/finance/balance',
      subscription: '/app/finance/subscription'
    },
    userApi: {
      main: '/app/user-api'
    },
    postbacks: {
      main: '/app/postbacks'
    },
    api: {
      main: '/app/api',
      userApi: {
        main: '/app/api/user-api'
      },
      postbacks: {
        main: '/app/api/postbacks'
      },
    },
    trialActivation: {
      main: '/app/trial-activation',
      pending: '/app/trial-activation/pending'
    },
    scoringSettings: {
      main: '/app/scoring-settings',
      baseRules: '/app/scoring-settings/base-rules',
      ipBlackList: '/app/scoring-settings/ip-black-list'
    }
  }
}

export function join(url: string, innerRoute: string): string {
  return `${ url }/${ innerRoute }`
}

export function pathUrl(url: string, index = 2, log: boolean | number = false): string {
  const r = url.split('/')[index] || ''
  if (log) console.log(url, r)
  return r
}

export function route(url: AppUrl, postfix?: string, log: boolean | number = false): string {
  const arr = url.split('/')
  let r = arr[arr.length - 1]
  if (postfix) r = `${r}/${postfix}`
  if (log) console.log(url, r)
  return r
}
